import InputAlert from "./InputAlert";

export default InputAlert
